module.exports = __webpack_public_path__ + "img/shengqu.d4562a5a.png";